const toId = require("to-id");
import { nanoid } from "nanoid/non-secure";

import { Persistable } from "@/store/Persistable";
import { Ingredient } from "@/models/Ingredient";

class Recipe implements Persistable {
  name: string;
  _id: string;
  _rev: string | null;
  ingredients: Array<Ingredient>;
  _attachments?: any;
  constructor(data: any) {
    this.name = data.name;
    this.ingredients = [];
    this._id = data._id || "Recipe:" + toId(this.name) + "-" + nanoid();
    this._rev = data._rev || null;
  }

  static fromPureObject(data: {
    name: string;
    ingredients: any;
    _attachments?: any | undefined;
  }): Recipe {
    data.ingredients = data.ingredients.map((ingredientData: any) =>
      Ingredient.fromPureObject(ingredientData)
    );
    let recipe = new Recipe(data);
    recipe.ingredients = data.ingredients;
    recipe._attachments = data._attachments;
    return recipe;
  }

  intoPureObject(): object {
    return this;
  }
}

export { Ingredient, Recipe };
